var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNavHome(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Nav Home") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.56688 12H11.465c.2802 0 .5095-.2299.535-.4854V4.94944c0-.45982-.2293-.89409-.586-1.14955L6.29299.0957956c-.17834-.1277275-.40764-.1277275-.58598 0L.585987 3.79989C.229299 4.05535 0 4.48962 0 4.94944v6.53966c0 .281.229299.5109.509554.5109H4.35669c.28025 0 .50955-.2299.50955-.5109V9.06227c0-.6131.48408-1.09846 1.09554-1.09846.61147 0 1.09554.48536 1.09554 1.09846v2.42683c0 .281.2293.5109.50956.5109Zm3.41412-.9953H8.0765V9.06326c0-1.14955-.94268-2.09473-2.08917-2.09473-1.1465 0-2.08917.94518-2.08917 2.09473v1.91594H.993697V4.92489c0-.12773.076433-.25546.178343-.33209l4.81529-3.47419 4.81527 3.49973c.1019.07664.1784.20437.1784.33209v6.05427Z",
    fill: "currentColor"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNavHome);
export default __webpack_public_path__ + "static/media/nav_home.cbca5761.svg";
export { ForwardRef as ReactComponent };